<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form size="small" inline label-width="100px">
            <el-form-item label="订单状态：">
              <el-radio-group
                v-model="tableFrom.is_sett"
                type="button"
                @change="getList(1)"
              >
                <el-radio-button label=""
                >全部
                  {{ "(" + orderChartType.all ? orderChartType.all : 0 + ")" }}
                </el-radio-button>
                <el-radio-button label="1"
                >已结算
                  {{
                    "(" + orderChartType.yes_sett
                      ? orderChartType.yes_sett
                      : 0 + ")"
                  }}
                </el-radio-button>
                <el-radio-button label="0"
                >未结算
                  {{
                    "(" + orderChartType.no_sett
                      ? orderChartType.no_sett
                      : 0 + ")"
                  }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间选择：" class="width100">
              <el-radio-group
                v-model="tableFrom.date"
                type="button"
                class="mr20"
                size="small"
                @change="selectChange(tableFrom.date)"
              >
                <el-radio-button
                  v-for="(item, i) in fromList.fromTxt"
                  :key="i"
                  :label="item.val"
                >{{ item.text }}
                </el-radio-button>
              </el-radio-group>
              <el-date-picker
                v-model="timeVal"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                size="small"
                type="daterange"
                placement="bottom-end"
                placeholder="自定义时间"
                style="width: 250px"
                @change="onchangeTime"
              />
            </el-form-item>

            <el-form-item
              label="关键字："
              class="width100"
              style="display: inline-block"
            >
              <el-input
                v-model="tableFrom.keywords"
                @keyup.enter.native="getList(1)"
                placeholder="请输入sku/分类名称"
                class="selWidth"
                size="small"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  size="small"
                  class="el-button-solt"
                  @click="getList(1)"
                />
              </el-input>
            </el-form-item>
            <el-form-item
              label="订单号："
              class="width100"
              style="display: inline-block"
            >
              <el-input
                v-model="tableFrom.order_sn"
                @keyup.enter.native="getList(1)"
                placeholder="请输入订单号"
                class="selWidth"
                size="small"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  size="small"
                  class="el-button-solt"
                  @click="getList(1)"
                />
              </el-input>
            </el-form-item>
            <el-form-item
              label="用户信息："
              class="width100"
              style="display: inline-block"
            >
              <el-input
                v-model="tableFrom.phone"
                @keyup.enter.native="getList(1)"
                placeholder="请输入用户手机号"
                class="selWidth"
                size="small"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  size="small"
                  class="el-button-solt"
                  @click="getList(1)"
                />
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <cards-data :card-lists="cardLists" />
        <div class="mb15">
          <el-button size="mini" class="mr10" @click="openVisibleMoney"
          >充值金额</el-button
          >
        </div>
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        size="small"
      >
        <el-table-column label="ID" prop="recovery_order_sett_id" min-width="60" />
        <el-table-column
          label="订单号"
          prop="recovery_order.order_sn"
          min-width="160"
        />
        <el-table-column
          label="用户手机号"
          prop="user.phone"
          min-width="100"
        />
        <el-table-column
          label="分类名称"
          prop="cate_name"
          min-width="100"
        />
        <el-table-column
          label="分类"
          prop="cate_name"
          min-width="100"
        />
        <el-table-column
          label="sku"
          prop="sku"
          min-width="100"
        />
        <el-table-column
          label="结算数量"
          prop="recovery_num"
          min-width="100"
        />
        <el-table-column
          label="结算金额"
          prop="recovery_price"
          min-width="100"
        />
        <el-table-column
          label="奖励甄豆"
          prop="reware_integral"
          min-width="100"
        />
        <el-table-column
          label="时间"
          prop="create_time"
          min-width="100"
        />
        <el-table-column
          label="备注"
          prop="sett_remark"
          min-width="100"
        />
        <el-table-column label="结算状态" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.is_sett == 1 ? "已结算" : "未结算" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结算时间" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.sett_time ? scope.row.sett_time : "-" }}
          </template>
        </el-table-column>

        <el-table-column label="操作" min-width="180" fixed="right">
          <template slot-scope="scope">
            <div style="display: flex; flex-wrap: wrap">
              <el-button
                type="text"
                size="small"
                v-if="scope.row.is_sett == 0"
                @click="orderHandleSett(scope.row)"
              >结算
              </el-button>
              <el-button
                type="text"
                size="small"
                v-if="scope.row.is_sett == 0"
                @click="handleDelete(scope.row)"
              >驳回
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :page-sizes="[20, 40, 60, 80]"
          :page-size="tableFrom.limit"
          :current-page="tableFrom.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { roterPre } from "@/settings";
import { fromList } from "@/libs/constants";
import {
  recoveryCategoryMenuListApi,
  recoveryOrderBatchSettApi,
  recoveryOrderCardListApi,
  recoveryOrderChartListApi,
  recoveryOrderListApi,
  recoverSearchUserApi,
  recoveryOrderDetailApi,
  amountHandleApi,
  orderHandleApi,
  recoveryOrderSettListApi,
  recoveryOrderSettChartListApi,
  recoveryOrderSettCardListApi,
  recoveryOrderDeleteApi, recoveryOrderCancelExpressApi, recoveryOrderSettHandleApi, recoveryOrderSettDeleteApi,
} from "@/api/recovery";
import cardsData from "@/components/cards";
import orderWornHandle from "@/views/recovery/order/orderWornHandle.vue";
import {changeAlipayBalanceApi} from "@/api/accounts";

export default {
  name: "OrderSettList",
  components: { orderWornHandle, cardsData },
  data() {
    return {
      dialogVisible: false, //  详情弹框
      nowOrder: {},
      visibleOrder: false,
      allocation_money: null,
      nowUser: {},
      pointUser: {
        phone: "",
      },
      allocation: "", //分配账号
      visibleMoney: false,
      props: { checkStrictly: true, emitPath: false },
      moren: require("@/assets/images/f.png"),
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
      listLoading: true,
      tableData: {
        data: [],
        total: 0,
      },
      roterPre: roterPre,
      tableFrom: {
        page: 1,
        limit: 20,
      },
      orderChartType: {},
      fromList: fromList,
      cardLists: [],
      timeVal: [],
      warehousTimeVal: [],
      loading: false,
      formData: {},
      ruleForm: {},
    };
  },
  mounted() {
    this.getList(1);
    this.headerList();
    this.checkedIds = [];
  },
  methods: {
    headerList() {
      recoveryOrderSettChartListApi()
        .then((res) => {
          this.orderChartType = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    // 选择时间
    selectChange(tab) {
      this.tableFrom.date = tab;
      this.tableFrom.page = 1;
      this.timeVal = [];
      this.getList(1);
    },
    // 具体日期
    onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.date = e ? this.timeVal.join("-") : "";
      this.tableFrom.page = 1;
      this.getList(1);
    },

    // 选择时间
    selectWarehousChange(tab) {
      this.tableFrom.warehous_date = tab;
      this.tableFrom.page = 1;
      this.warehousTimeVal = [];
      this.getList(1);
    },
    // 具体日期
    onchangeWarehousTime(e) {
      this.warehousTimeVal = e;
      this.tableFrom.warehous_date = e ? this.warehousTimeVal.join("/") : "";
      this.tableFrom.page = 1;
      this.getList(1);
    },
    // 列表
    getList(num) {
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.appraisal_type_list = 1;
      this.tableFrom.uid = 7598;
      recoveryOrderSettListApi(this.tableFrom)
        .then((res) => {
          this.tableData.data = res.data.list;
          this.tableData.total = res.data.count;
          this.getCardList();
          this.checkedIds = [];
          this.listLoading = false;
        })
        .catch((res) => {
          this.listLoading = false;
          this.$message.error(res.message);
        });
    },
    pageChange(page) {
      this.tableFrom.page = page;
      this.getList("");
    },
    handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList("");
    },
    getCardList() {
      recoveryOrderSettCardListApi(this.tableFrom)
        .then((res) => {
          this.cardLists = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    openVisibleMoney(){
      this.$modalForm(changeAlipayBalanceApi()).then(() => this.getList(''))
    },
    // 结算
    orderHandleSett(row) {
      this.$modalSure("确定要结算吗？").then(() => {
        recoveryOrderSettHandleApi(row.recovery_order_sett_id)
          .then(({ message }) => {
            this.$message.success(message);
            this.getList("");
          })
          .catch(({ message }) => {
            this.$message.error(message);
          });
      });
    },
    // 删除
    handleDelete(row) {
      this.$modalSure("确定要驳回吗？").then(() => {
        recoveryOrderSettDeleteApi(row.recovery_order_sett_id)
          .then(({ message }) => {
            this.$message.success(message);
            this.getList();
          })
          .catch(({ message }) => {
            this.$message.error(message);
          });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.boxDetial .el-form-item {
  margin-bottom: 0px;
}

.box-container {
  overflow: hidden;
}

.box-container .list {
  float: left;
  line-height: 40px;
}

.box-container .sp {
  width: 50%;
}

.box-container .sp3 {
  width: 33.3333%;
}

.box-container .sp100 {
  width: 100%;
}

.box-container .list .name {
  display: inline-block;
  width: 150px;
  text-align: right;
  color: #606266;
}

.box-container .list.image {
  margin-bottom: 40px;
}

.box-container .list.image img {
  position: relative;
  top: 40px;
}

/deep/ .el-form-item__content .el-rate {
  position: relative;
  top: 8px;
}

.sku-tb {
  border: 1px solid black;
  border-collapse: collapse;
  margin-bottom: 20px;
  width: 100%;
  tr {
    th,
    td {
      border: 1px solid black;
      text-align: center;

      .sku-name {
        margin: 0 auto;
        width: 100px;
        /*height: 30px;*/
        /*overflow: hidden;*/
        line-height: 24px;
        text-overflow: ellipsis;
        /*word-break: keep-all;*/
      }
    }
  }
}

.skuList {
  border-bottom: 2px solid #f4f4f5;
  margin-bottom: 10px;
}
.blodClass {
  font-size: 14px;
  color: red;
  font-weight: bold;
}
</style>
